<template>
  <b-col cols="12" class="text-left mt-4">
    <div class="avatar-box d-flex">
      <div class="avatar mt-5">
        <b-icon
          icon="hand-index-thumb"
          variant="danger"
          font-scale="4.5"
          class="border rounded-circle border-danger bg-white p-3"
        ></b-icon>
      </div>
      <div class="black-box">
        <b-overlay :show="loading" rounded="sm">
          <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" v-if="show">
            <b-form-group id="input-group-name" label="* Nome dell'Organizzazione:" label-for="input-name">
              <b-form-input
                id="input-name"
                v-model="organization.name"
                required
                placeholder="Inserisci il nome completo dell'organizzazione"
                name="name"
              ></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-organization" label="La nostra organizzazione è una sede locale di:">
              <v-select
                id="input-organization"
                placeholder="Se pertinente, seleziona l’organizzazione principale (se già accreditata)"
                :options="organizations"
                label="name"
                :reduce="(organization) => organization.id"
                v-model="organization.parent_id"
              ></v-select>
            </b-form-group>

            <b-form-group id="input-group-address" label="* Indirizzo:" label-for="input-address">
              <b-form-input
                id="input-address"
                v-model="organization.address"
                type="text"
                required
                placeholder="Inserisci l'indirizzo della tua organizzazione"
                name="input-address"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-city" label="* Città:" label-for="input-city">
              <b-form-input
                id="input-city"
                v-model="organization.city"
                type="text"
                required
                placeholder="Inserisci la città"
                name="email"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-province" label="* Provincia:" label-for="input-province">
              <b-form-input
                id="input-province"
                v-model="organization.province"
                type="text"
                required
                placeholder="Provincia (es. To)"
                maxlength=2
                name="province"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-mail" label="* Email dell'organizzazione:" label-for="input-mail">
              <b-form-input
                id="input-mail"
                v-model="organization.email"
                type="email"
                required
                placeholder="Inserisci l'email dell'organizzazione"
                name="email"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-web" label="Sito Web dell'organizzazione:" label-for="input-web">
              <b-form-input
                id="input-web"
                v-model="organization.web"
                type="text"
                placeholder="Inserisci l'indirizzo del sito Web dell'organizzazione'"
                name="web"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              id="input-group-ref_person"
              label="* Nome e Cognome della Persona di Contatto:"
              label-for="input-ref_person"
            >
              <b-form-input
                id="input-ref_person"
                v-model="organization.ref_person"
                type="text"
                required
                placeholder="* Inserisci Nome e Cognome di un responsabie dell'organizzazione"
                name="email"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-refmail" label="* Email della persona di contatto:" label-for="input-refmail">
              <b-form-input
                id="refmail"
                v-model="organization.ref_email"
                type="email"
                required
                placeholder="* Inserisci l' Email del responsabile dell'organizzazione"
                name="email"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-phone" label="* Cellulare della persona di contatto:" label-for="input-phone">
              <b-form-input
                id="input-mail"
                v-model="organization.ref_phone"
                type="text"
                required
                placeholder="Inserisci il Cellulare del responsabile dell'organizzazione"
                name="email"
              ></b-form-input>
            </b-form-group>
            <div>
              <b-button size="sm" pill type="submit" variant="primary" :disabled="loading"
                >Richiedi Accreditamento</b-button
              >
            </div>
            <small>* I campi contrassegnati da un asterisco sono obbligatori.</small>
            <b-alert :show="errorMessage.length" variant="danger">{{ errorMessage }}</b-alert>
            <ul>
              <li v-for="error in errors.all()" :key="error.id">{{ error }}</li>
            </ul>
          </b-form>
        </b-overlay>
      </div>
    </div>
  </b-col>
</template>

<script>
//import axios from "axios";
import UserService from "@/services/user.service";
import Util from "@/mixing/util";
//import User from "@/models/user";
//axios.defaults.withCredentials = true;

export default {
  name: "Accredits",
  mixins: [Util],
  data() {
    return {
      organization: {},
      //url_accredita: process.env.VUE_APP_ROOT + "/organizations/add",
      url_accredita: "/test",
      organizations: [],
      show: true,
      //userType: this.$route.params.userType,
      loading: false,
      message: null,
      errorMessage: "",
      compliance: false,
      privacy: false,
    };
  },
  mounted() {
    UserService.getOrganizationsList().then((response) => (this.organizations = response.data));
  },
  methods: {
    onSubmit() {
      this.loading = true;
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          this.loading = false;
          return;
        }
        this.$store.dispatch("auth/registerOrg", this.organization).then(
          () => {
            this.$bvModal
              .msgBoxOk(
                "Organizzazione registrata con successo. A breve riceverai il codice di accreditamento per la tua organizzazione.",
                {
                  title: "Registrato con successo",
                }
              )
              .then((response) => {
                this.$router.push("/");
                console.log(response)
              });
          },
          (error) => {
            this.loading = false;
            this.errorMessage = error.response.data.message;
          }
        );
      });
      this.loading = false;
    },
    onReset() {
      //this.user = new User("", "");
      //this.user.consens = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>
<style>
.btn {
  width: 180px !important;
}
</style>
